var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "tr",
    {
      on: {
        click: _vm.onSelect,
      },
    },
    [
      _c("td", [
        _c("label", [
          _c("input", {
            attrs: {
              type: "checkbox",
            },
            domProps: {
              checked: _vm.isChecked,
            },
            on: {
              change: _vm.onCheckboxChange,
            },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "sr-only",
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$gettextInterpolate(
                    _vm.$gettext("%{context} auswählen"),
                    {
                      context: _vm.stockImage.attributes.title,
                    }
                  )
                )
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("td", [
        _c(
          "div",
          [
            _vm.thumbnailUrl
              ? _c("Thumbnail", {
                  staticStyle: {
                    background: "var(--light-gray-color-40)",
                  },
                  attrs: {
                    url: _vm.thumbnailUrl,
                    width: "6rem",
                    contain: "",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _c("div", [_vm._v(_vm._s(_vm.stockImage.attributes.title))]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "span",
                  {
                    staticClass: "stock-image-author",
                  },
                  [_vm._v(_vm._s(_vm.stockImage.attributes.author))]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "stock-image-tags",
                  },
                  _vm._l(_vm.stockImage.attributes.tags, function (tag) {
                    return _c(
                      "button",
                      {
                        key: tag,
                        staticClass: "stock-image-tag",
                        attrs: {
                          type: "button",
                        },
                        on: {
                          click: function click($event) {
                            return _vm.onTagClick(tag)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(tag) +
                            "\n                        "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c(
                "ul",
                {
                  staticClass: "stock-image-palette",
                  attrs: {
                    title: _vm.$gettext("Bildfarben"),
                    role: "presentation",
                  },
                },
                _vm._l(_vm.palette, function (color, index) {
                  return _c("li", {
                    key: index,
                    style: "background-color: rgb("
                      .concat(color[0], " ")
                      .concat(color[1], " ")
                      .concat(color[2], ");"),
                    attrs: {
                      alt: color.join(","),
                    },
                  })
                }),
                0
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "td",
        [
          _c("studip-icon", {
            attrs: {
              shape: "file-pic",
              alt: "",
            },
          }),
          _vm._v(
            "\n        " + _vm._s(_vm.imageFormat(_vm.stockImage)) + "\n    "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "td",
        [
          _c("studip-file-size", {
            attrs: {
              size: _vm.stockImage.attributes.size,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("td", [
        _vm._v(
          _vm._s(_vm.stockImage.attributes.width) +
            " × " +
            _vm._s(_vm.stockImage.attributes.height)
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }